import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { AiOutlineEye, AiOutlineDown, AiOutlineUp } from "react-icons/ai";
import { useNavigate } from "react-router";
import { IoMdArrowRoundBack } from "react-icons/io";
import { message, Tooltip, Pagination } from "antd";
import ViewInvoiceDetails from "./ViewInvoiceDetails";
import Loader from "../Loader/Loader";
import { editInvoiceDetails } from "../../webServices/Apis";

const ArchivedInvoices = () => {
  const location = useLocation();
  const navigation = useNavigate();
  const { invoiceDetails } = location.state || {};
  const [viewInvoice, setViewInvoice] = useState(false);
  const [invoiceData, setInvoiceData] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState({});

  const archivedInvoices = invoiceDetails
    .map((subContractor) => {
      const archived = subContractor?.invoices.filter(
        (invoice) => invoice?.projectInvoice?.invoiceAccepted
      );

      if (archived.length > 0) {
        return {
          ...subContractor,
          invoices: archived,
        };
      } else {
        return null;
      }
    })
    .filter(Boolean);

  const reverseArchivedInvoices = [...archivedInvoices].reverse();

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentInvoice = reverseArchivedInvoices.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  console.log("aada", reverseArchivedInvoices);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleActiveInvoice = async (invoice) => {
    if (!invoice || !invoice.projectInvoice) {
      console.error("Invalid invoice data");
      return;
    }

    const updateData = {
      ...invoice,
      projectInvoice: {
        ...invoice.projectInvoice,
        invoiceAccepted: false, // Set to false to change archived invoice back to active
      },
    };

    setLoading(true);

    try {
      console.log(
        "Updating invoice data:",
        updateData?.projectInvoice?.invoiceAccepted
      );

      const response = await editInvoiceDetails(updateData);
      if (response?.data?.success) {
        message.success(
          response?.data?.message || "Invoice successfully changed to active"
        );
        navigation("/invoice");
      }
    } catch (error) {
      console.log("Error while editing archived invoice", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  };

  const handleViewInvoice = (invoice) => {
    setViewInvoice(true);
    setInvoiceData(invoice);
  };

  const handleBack = () => {
    navigation("/invoice");
  };

    const toggleExpand = (subContractorId) => {
    setExpanded((prev) => ({
      ...prev,
      [subContractorId]: !prev[subContractorId],
    }));
  };

  return (
    <>
      {loading && <Loader />}
      <div className="p-4">
        <div className="flex flex-row justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">Archived Invoices</h2>
          <Tooltip title="Back to active invoices">
            <button
              className="bg-blue-200 hover:bg-blue-400 font-bold w-10 h-10 rounded-full flex items-center justify-center border border-gray-900 shadow-md"
              onClick={handleBack}
            >
              <IoMdArrowRoundBack className="text-md" />
            </button>
          </Tooltip>
        </div>

        <div className="mt-6">
          {currentInvoice?.length > 0 ? (
            currentInvoice.map((group) => (
              <div
                key={group?.subContractorId}
                className="mb-6 border border-gray-300 rounded"
              >
                {/* Header with toggle */}
                <div
                  className="flex justify-between items-center bg-gray-800 text-white px-4 py-3 cursor-pointer"
                  onClick={() => toggleExpand(group?.subContractorId)}
                >
                  <h2 className="font-semibold text-lg">
                    Subcontractor : {group?.subContractorName}
                  </h2>
                  <span className="text-xl">
                    {expanded[group?.subContractorId] ? (
                      <AiOutlineUp />
                    ) : (
                      <AiOutlineDown />
                    )}
                  </span>
                </div>

                {/* Table - visible only if expanded */}
                {expanded[group?.subContractorId] && (
                  <div className="border border-gray-800 border-t-0 rounded-b">
                    <table className="min-w-full bg-white">
                      <thead className="bg-gray-800 text-white">
                        <tr>
                          <th className="py-3 px-4 text-center text-sm">#ID</th>
                          <th className="py-3 px-4 text-center text-sm">
                            Submitted Date
                          </th>
                          <th className="py-3 px-4 text-center text-sm">
                            Assigned Project Name
                          </th>
                          <th className="py-3 px-4 text-center text-sm">
                            Invoice Status
                          </th>
                          <th className="py-3 px-4 text-center text-sm">
                            Paid Status
                          </th>
                          <th className="py-3 px-4 text-center text-sm">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {group?.invoices?.map((invoice, index) => (
                          <tr
                            key={invoice?.projectInvoice?.id || index}
                            className={`text-center transition ${
                              index % 2 === 0 ? "bg-white" : "bg-gray-300"
                            }`}
                          >
                            <td className="py-2 px-4 border-b">
                              {invoice?.projectInvoice?.id}
                            </td>
                            <td className="py-2 px-4 border-b">
                              {invoice?.projectInvoice?.startDate
                                ? formatDate(invoice?.projectInvoice?.startDate)
                                : "N/A"}
                            </td>
                            <td className="py-2 px-4 border-b">
                              {invoice?.projectInvoice?.assignProjectName}
                            </td>
                            <td className="py-2 px-4 border-b">
                              {invoice?.projectInvoice?.invoiceAccepted
                                ? "Archived"
                                : "Active"}
                            </td>
                            <td
                              className={`py-2 px-4 border-b ${
                                invoice?.projectInvoice?.paidStatus
                                  ? "text-green-500"
                                  : "text-yellow-500"
                              }`}
                            >
                              {invoice?.projectInvoice?.paidStatus
                                ? "Approved"
                                : "Pending"}
                            </td>

                            <div className="flex justify-center">
                              <td className="py-2 px-4 border-b w-1/6 flex gap-2 justify-center">
                                <button
                                  onClick={() => handleViewInvoice(invoice)}
                                  className="text-blue-500 hover:text-blue-700"
                                >
                                  <AiOutlineEye className="text-xl" />
                                </button>
                                <Tooltip title="Click to make invoice active">
                                  <button
                                    className="border border-gray px-4 py-1 bg-blue-200 hover:bg-blue-400 rounded-md"
                                    onClick={() => handleActiveInvoice(invoice)}
                                  >
                                    Active
                                  </button>
                                </Tooltip>
                              </td>
                            </div>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    {/* ✅ Buttons below the table */}
                    {/* <div className="flex justify-end gap-3 p-4 bg-gray-50 border-t">
                                     <button
                                       className="bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded"
                                       onClick={() => handleApprove(group)}
                                     >
                                       Approve All
                                     </button>
                                     <button
                                       className="bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded"
                                       onClick={() => handleArchive(group)}
                                     >
                                       Archive All
                                     </button>
                                   </div> */}
                  </div>
                )}
              </div>
            ))
          ) : (
            <p className="text-center py-4">No active invoice found</p>
          )}
        </div>

        <div className="mt-4 flex justify-end">
          <Pagination
            current={currentPage}
            total={archivedInvoices?.length}
            pageSize={itemsPerPage}
            onChange={handlePageChange}
          />
        </div>
      </div>

      {viewInvoice && (
        <ViewInvoiceDetails
          invoiceDetails={invoiceData}
          close={() => setViewInvoice(false)}
        />
      )}
    </>
  );
};

export default ArchivedInvoices;
